import axios from '@/plugins/axios'
import {Base64} from 'js-base64'
import md5 from 'js-md5'
export const loginValidate = function ({commit}, vm) {
  const pwd = md5(vm.formInline.password)
  return new Promise((resolve, reject) => {
    axios({
      url: `user`,
      headers: {
        'Authorization': `Basic ${Base64.encode(`${vm.formInline.user}:${pwd}`)}`
      },
      data: {
        captcha: vm.formInline.vcode
      },
      method: 'GET'
    }).then(({data, headers}) => {
      if (data.authenticated) {
        resolve(data)
        return false
      }
      reject(data)
    }).catch((err) => reject(err))
  })
}
export const getUser = function ({commit}) {
  return new Promise((resolve, reject) => {
    resolve({
      user: 'lk',
      password: '888888'
    })
  })
}

export const generateRoutes = function ({commit}) {
  return new Promise((resolve, reject) => {
    resolve({
      user: 'lk',
      password: '888888'
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js